// package imports
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// CSS imports
import './BlogPreviewCard.css';

// Component imports
import PrimaryButton from '../../buttons/primaryButton/PrimaryButton';
import DeleteButton from '../../buttons/deleteButton/DeleteButton';
import Spinner from '../../spinner/Spinner';

// Type imports
import { BlogPreview } from '../../../types/blog/BlogPreview';
import { User } from '../../../types/user/User';
import { getCloudinaryImage } from '../../../helpers/functions/getCloudinaryImage';

type Props = {
  className?: string;
  user: User;
  post: BlogPreview;
  index: number;
  deleteBlogPost: (id: string, x: number) => Promise<void>;
};

const BlogPreviewCard: React.FC<Props> = ({
  className,
  user,
  post,
  index,
  deleteBlogPost,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const triggerDeleteBlogPost = async () => {
    setIsLoading(true);
    await deleteBlogPost(post.id, index);
    setIsLoading(false);
  };

  return (
    <div className={`BlogPreviewCard ${className ? className : ''}`}>
      <div className='side-container'>
        {post.titleImg ? (
          <img
            src={getCloudinaryImage(post.titleImg, 400)}
            alt={post.title}
            className='title-image'
          />
        ) : null}

        <span>{post.title}</span>
      </div>
      <div className='side-container'>
        <Link
          to={'/blog/' + post.urlTitle + '-' + post.id + '/edit'}
          className='edit-link'
        >
          <PrimaryButton label='Edit' className='edit-button' />
        </Link>
        <DeleteButton onClick={triggerDeleteBlogPost} />
      </div>
      {isLoading ? (
        <div className='loader-overlay'>
          <Spinner isLoading={true} />
        </div>
      ) : null}
    </div>
  );
};

export default BlogPreviewCard;
